/*!
 * lightbox.js v1.0.0
 * Author: Oleg Kuznetsov
 * Author URL: https://designbyoleg.com
 * Description: Lightbox component
 * License: MIT
 */
(function($) {
    $.fn.videoLoader = function(options = {}) {
      return this.each(function() {
        const $el = $(this);
        const settings = $.extend({
          platform: $el.data('platform'),
          videoId: $el.data('video-id'),
          thumbnail: $el.data('thumbnail'),
          target: $el.data('target'), // supports data-target attr
          showInSelf: $el.data('show-in-self') !== false, // true unless explicitly false
          onClick: null,
          loadTrigger: null,  // optional lazy loader hook
          showTrigger: null,  // optional custom show trigger
          autoplay: 1,        // optional custom show trigger
          debug: true         // Output console messages?
        }, options);

        /* Log to console helper */
        const log = function(...args) {
            if (settings.debug) {
                console.log('[videoLoader]', ...args);
            }
        };

        /* Validate inputs */
        if (!settings.videoId) {
            console.error('Video ID is required.');
            return this;
        }
        if (!['youtube', 'vimeo'].includes(settings.platform)) {
            console.error('Platform must be "youtube" or "vimeo".');
            return this;
        }
  
        /* We'll store generated HTML here */
        const cache = {};

        function load() {
            const key = settings.platform + ':' + settings.videoId;

            log('Is html in cache?');

            /* Return cached version if available */
            if (cache[key]) return cache[key];
            
            log('No, it\s not in cache.');
            log(settings.autoplay);

            let src = '';
            if (settings.platform === 'youtube') {
            //   src = 'https://www.youtube.com/embed/' + settings.videoId + '?autoplay=1&rel=0';
              src = `https://www.youtube.com/embed/${settings.videoId}?autoplay=${settings.autoplay}&rel=0`;
            } else if (settings.platform === 'vimeo') {
            //   src = 'https://player.vimeo.com/video/' + settings.videoId + '?autoplay=1';
              src = `https://player.vimeo.com/video/${settings.videoId}?autoplay=${settings.autoplay}`;
            }
            log(src);
            const $wrapper = $('<div>').addClass('video-embed-wrapper');
            const $iframe = $('<iframe>', {
                // src: 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&enablejsapi=1&rel=0',
                src: src,
                frameborder: 0,
                allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
                allowfullscreen: true,
                class: 'video-embed-iframe',
                // width: '760',
                // height: '570'
            });

            /* Potentially turn these into options */
            let aspectHeight = 9;
            let aspectWidth = 16;
            const paddingBottom = (aspectHeight / aspectWidth * 100) + '%';
    
            // Apply responsive CSS
            $wrapper.css({
                position: 'relative',
                paddingBottom: paddingBottom, // '56.25%' = 16:9 aspect ratio (9/16 = 0.5625)
                height: 0,
                overflow: 'hidden'
            });
            $iframe.css({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            });

            // const html = `<iframe src="${src}" frameborder="0" allowfullscreen></iframe>`;
            const html = $wrapper.append($iframe);
            cache[key] = html;
            return html;
        }
  
        function show(videoHtml) {

            if (settings.showInSelf !== false) {
              $el.html(videoHtml); // show in self unless explicitly disabled
            }
          
            if (settings.target) {
              $(settings.target).html(videoHtml); // also show in target if specified
            }
        }
  
        // Store public API on element
        $el.data('videoLoader', {
            load,
            show,
            loadAndShow() {
                const html = load();
                show(html);
            },
            resetShown() {
                $el.data('hasShown', false);
            }
        });
  
        /**
         * Get thumbnail from YouTube if none from user
         */
        // Code here

        // Thumbnail setup
        if (settings.thumbnail) {
          $el.html(`<img src="${settings.thumbnail}" alt="video thumbnail">`);

          const $play_button = $(`
            <div class="play-button">
                <svg class="play-icon" width="320" height="278" viewBox="0 0 320 278" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <path id="icon-solid-triangle" fill="#000000" fill-rule="evenodd" stroke="none" d="M 159.713501 0.371887 L -0.286493 277.5 L 319.713501 277.5 Z"/>
                </svg>
            </div>
          `);
          $el.append($play_button);
          
        }
        // Default click behavior
        $el.on('click', function (e) {
            e.preventDefault();

            stopAllVideos($el);
            
            log('Clicked');

            /* Get the video HTML */
            const videoHtml = load();

            /* Run onClick function if supplied */
            if (typeof settings.onClick === 'function') {
                settings.onClick(videoHtml);
            }

            /* Did we show this video already? */
            if ($el.data('hasShown')) return;
            
            /* NOTE: Is this really required, since show() checks both target and showInSelf ? */
            // if (!settings.target && !settings.showInSelf) {
            //     return; // do nothing else
            // }
            
            /* Finally, show it! */
            show(videoHtml);

            /* Remember that we showed the video */
            $el.data('hasShown', true);
            
        });
  
        /**
         * External loadTrigger (e.g., lazy loader)
         * 
         * This kind of works whit the folowing example code.
         * The does html get generated on mouseover.
         * But NOT 'loaded' (into DOM?)
         * So it does take some time actually load the video
         *      $('.video-loader-2').videoLoader({
                    target: '#tv',
                    showInSelf: false, // only in .tv
                    loadTrigger: function($el, load) {
                        $el.on('mouseover', function () {
                            load();
                        });
                    }
                });
         */
        if (typeof settings.loadTrigger === 'function') {
            settings.loadTrigger($el, load);
        }

        
    
        
      });
    };

    /* Check if this is a videoLoader */
    $.fn.isVideoLoader = function() {
        return this.length > 0 && this.data('videoLoader') !== undefined;
    };


  function stopAllVideos(excludeIframe = null) {
    $('iframe').each(function() {
        const $iframe = $(this);
        // Skip the excluded iframe
        if (excludeIframe && $iframe.is(excludeIframe)) {
            return;
        }
        let src = $iframe.attr('src');
        // Check if the iframe is YouTube or Vimeo
        if (src && (src.includes('youtube.com') || src.includes('vimeo.com'))) {
            // Modify src to disable autoplay
            if (src.includes('autoplay=1')) {
                src = src.replace('autoplay=1', 'autoplay=0');
            } else if (src.includes('autoplay=0')) {
                return;
            } else {
                src += (src.includes('?') ? '&' : '?') + 'autoplay=0';
            }
            // Reset src to stop playback
            $iframe.attr('src', src);
        }
    });
  }
})(jQuery);